import { Controller } from "@hotwired/stimulus"

// Shows the input panel matching the currently-checked source radio and hides
// the others — so a single card can offer "upload a file / use a URL / pick an
// existing track" without cluttering the page.
//
// Markup:
//   <div data-controller="asset-source">
//     <input type="radio" name="cover_source" value="upload"
//            data-asset-source-target="radio" data-action="asset-source#choose">
//     <input type="radio" name="cover_source" value="url"
//            data-asset-source-target="radio" data-action="asset-source#choose">
//     <div data-asset-source-target="panel" data-asset-source-panel="upload">…</div>
//     <div data-asset-source-target="panel" data-asset-source-panel="url" hidden>…</div>
//   </div>
export default class extends Controller {
  static targets = ["radio", "panel"]

  connect() {
    this.choose()
  }

  choose() {
    const selected = this.radioTargets.find((radio) => radio.checked)?.value
    this.panelTargets.forEach((panel) => {
      const active = panel.dataset.assetSourcePanel === selected
      panel.hidden = !active
      // Disable inputs in inactive panels — a merely-hidden control is still
      // validated AND submitted by the browser, which both blocks submit
      // ("invalid form control is not focusable") and leaks stale values.
      panel.querySelectorAll("input, select, textarea").forEach((field) => {
        field.disabled = !active
      })
    })
  }
}
